<app-banner></app-banner>

<div class="container-fluid innerPageMenu">
  <div class="row">
      <div class="col-md-3">
          <nav id="secondary-navigation">
              <!-- Header -->
              <header class="header">
                  <h5>Awards</h5>
              </header>
              <!-- /Header -->
              <ul>
                  <li routerLinkActive="active">
                      <a routerLink="/award/inter" >Inter-House Results</a>
                  </li>
                  <li routerLinkActive="active">
                    <a routerLink="/award/star" >Star Awardees</a>
                </li>
                <li routerLinkActive="active">
                  <a routerLink="/award/notability" >Notability</a>
              </li>
                 
              </ul>
          </nav>
      </div>
      <div class="col-md-9">
          <router-outlet></router-outlet>
      </div>
  </div>
</div>